import React, { useEffect } from "react";
import CryptoPayment from "./crypto-payment";
import MassPay from "./mass-pay";
import { useDispatch } from "react-redux";
import { getPayeeData } from "../../../../store/actions";

export default function RenderSteps({ type, active,
  amount,
  setActive,
  setShowKyt,
  setShowKytBlocked,
  step }) {
  const crypto = 'crypto';
  const nonCrypto = 'non-crypto';
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getPayeeData());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  switch (type) {
    case crypto:
      return <CryptoPayment active={active} amount={amount} setActive={setActive} setShowKyt={setShowKyt} setShowKytBlocked={setShowKytBlocked} step={step} />
    case nonCrypto:
      return <MassPay active={active} amount={amount} setActive={setActive} setShowKyt={setShowKyt} setShowKytBlocked={setShowKytBlocked} step={step} />;
    default:
      return <></>
  }
}